import React, { useState } from 'react';
import { Phone, Mail, Clock, MapPin, ChevronDown } from 'lucide-react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import ServiceArea from '../components/ServiceArea';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <Gallery />
      <Process />
      <Testimonials />
      <ServiceArea />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
